import * as React from "react";
import * as RadioGroupPrimitive from "@radix-ui/react-radio-group";
import {LayoutGroup, motion} from "framer-motion";
import {cn} from "../lib/utils";

interface RadioGroupProps
  extends React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Root> {
  small?: boolean;
  medium?: boolean;
}

const RadioGroup = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Root>,
  RadioGroupProps
>(({className, medium, small, ...props}, ref) => {
  return (
    <LayoutGroup id={Math.floor(Math.random() * 100).toString()}>
      <RadioGroupPrimitive.Root
        className={cn(
          "flex bg-slate-100 rounded-xl [&:has(*:focus-visible)]:ring-2 ring-green-900/50 group/parent p-1",
          "data-[small=true]:rounded-full data-[small=true]:p-[2px]",
          className
        )}
        data-small={small ? small.toString() : undefined}
        data-medium={medium ? medium.toString() : undefined}
        {...props}
        ref={ref}
      />
    </LayoutGroup>
  );
});
RadioGroup.displayName = RadioGroupPrimitive.Root.displayName;

const RadioGroupItem = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Item>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Item>
>(({className, children, ...props}, ref) => {
  return (
    <RadioGroupPrimitive.Item
      ref={ref}
      className={cn(
        "grid w-full focus:outline-none disabled:cursor-not-allowed disabled:opacity-50 group",
        className
      )}
      {...props}
    >
      <RadioGroupPrimitive.Indicator
        className="[grid-area:1/1] bg-white shadow-sm w-full h-full rounded-lg group-data-[small=true]/parent:rounded-full"
        asChild
      >
        <motion.div
          layoutId="indicator"
          transition={{
            type: "spring",
            stiffness: 2000,
            damping: 40,
            mass: 0.01,
          }}
        />
      </RadioGroupPrimitive.Indicator>
      <div
        className="[grid-area:1/1] z-10 h-full flex justify-center items-center font-bold text-green-900 opacity-30 hover:opacity-70 px-3 group-data-[state=checked]:opacity-100
        text-2xl group-data-[small=true]/parent:text-sm 
      "
      >
        {children || props.value}
      </div>
    </RadioGroupPrimitive.Item>
  );
});
RadioGroupItem.displayName = RadioGroupPrimitive.Item.displayName;

export {RadioGroup, RadioGroupItem};
